import { render, staticRenderFns } from "./Projet.vue?vue&type=template&id=e2029b20"
import script from "./Projet.vue?vue&type=script&lang=js"
export * from "./Projet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/tonumeric/poureux-gestion/projects/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2029b20')) {
      api.createRecord('e2029b20', component.options)
    } else {
      api.reload('e2029b20', component.options)
    }
    module.hot.accept("./Projet.vue?vue&type=template&id=e2029b20", function () {
      api.rerender('e2029b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Projet.vue"
export default component.exports